import { Popover } from 'bootstrap';

document.addEventListener('turbolinks:load', function () {
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  popoverTriggerList.forEach(function (popoverTriggerEl) {
    new Popover(popoverTriggerEl);
  });
});